import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const INTEGRATIONS_FIELD_MAPPINGS_QUERY_KEY = 'integrations-field-mappings';

export function useGetExternalIntegrationFieldMappingsQuery({
	integrationProvider,
	objectType = 'Contact',
	impersonationContext,
	enabled = true,
	meta,
}: {
	integrationProvider: Api.IntegrationProvider;
	objectType?: string;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IIntegrationFieldMapping[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/fieldMappings?objectType=${objectType}`,
				}),
				'GET'
			);
		},
		queryKey: [INTEGRATIONS_FIELD_MAPPINGS_QUERY_KEY, integrationProvider, objectType, impersonationContext],
		meta,
	});
}

export const invalidateFieldMappingsQuery = ({
	impersonationContext,
}: {
	impersonationContext: Api.IImpersonationContext;
}) => reactQueryClient.invalidateQueries({ queryKey: [INTEGRATIONS_FIELD_MAPPINGS_QUERY_KEY, impersonationContext] });
